import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-redesign',
  templateUrl: './contact-redesign.component.html',
  styleUrls: ['./contact-redesign.component.scss']
})
export class ContactRedesignComponent {

}
